import React, { useState, useRef } from "react";
import axios from "axios";
import Footer from "../components/Footer.jsx";
import { motion } from "framer-motion";
import logo from "../assets/images/logo-login.png";
import loginCar from "../assets/images/login-car.png";
import passIcon from "../assets/images/passIcon.png";
import eyeIcon from "../assets/images/eye.png";
import eyeOffIcon from "../assets/images/eye-off.png";
import phoneIcon from "../assets/images/phone-icon.png";
import nameIcon from "../assets/images/fullnameIcon.png";
import { API_BASE_URL } from "../utils/api";
import "../styles/LoginPage.css";
import { initNotifications } from "../firebaseConfigNotification";

const VAPID_KEY =
  "BKlu2F5HfRL73j85gRO-PlrDPjpJC9AhS8HPDSC7F_8CotqL2p2C9ek2gcBmC2Uc80wKe5W0nPYXoNkqvcqjsxwBNoUrZTFXTVHGKak0b2xryw-DhxQ6dam1zWxy3trSDg7FJep_B8SjAJcX6_U3OZRUaCTlOjA09_dl1aPWDRKExI";

import MobileFooterSheet from "../components/MobileFooterSheet.jsx";

export default function RegisterPage({ onBack, setCurrentView, onLoggedIn }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  // store **national** part only (5XXXXXXXX)
  const [phoneLocal, setPhoneLocal] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [showPw2, setShowPw2] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  /* ---------- KSA phone helpers ---------- */
  const normalizeKsaNational = (raw) => {
    let d = String(raw || "").replace(/\D/g, "");
    if (d.startsWith("966")) d = d.slice(3);
    if (d.startsWith("0")) d = d.slice(1);
    return d;
  };
  const isValidKsaNational = (n) => /^5\d{8}$/.test(n);
  const toE164 = (n) => `+966${n}`;

  const handlePhoneChange = (val) => {
    const normalized = normalizeKsaNational(val).slice(0, 9); // cap 9 digits
    setPhoneLocal(normalized);
  };

  // Helper: map backend error messages to localized ones
  // Maps backend error payloads/strings to Arabic, including "Validation errors"
  const mapErrorMessage = (raw) => {
    // Helper: trim trailing punctuation (.,)
    const trimPunct = (s) => (s || "").replace(/[.,\s]+$/g, "").trim();

    // Helper: join Arabic clauses with " و"
    const joinArabicClauses = (clauses) => {
      if (!clauses.length) return "";
      const [first, ...rest] = clauses;
      return [trimPunct(first), ...rest.map((c) => "و" + trimPunct(c))].join(" ");
    };

    // Translate common password rule messages to Arabic clauses
    const translatePasswordRule = (msg) => {
      const m = (msg || "").toLowerCase();
      if (m.includes("at least 8 characters")) {
        return "يجب أن تتكون كلمة المرور من 8 محارف على الأقل";
      }
      if (m.includes("at least one special character")) {
        return "أن تحتوي على رمز مميز مثل @";
      }
      if (m.includes("uppercase")) {
        return "أن تحتوي على حرف كبير واحد على الأقل";
      }
      if (m.includes("lowercase")) {
        return "أن تحتوي على حرف صغير واحد على الأقل";
      }
      if (m.includes("number") || m.includes("digit") || m.includes("numeric")) {
        return "أن تحتوي على رقم واحد على الأقل";
      }
      if (m.includes("confirmed") || m.includes("match")) {
        return "وتطابق تأكيد كلمة المرور";
      }
      return null; // fallback: unknown rule, ignore here
    };

    // If backend returned a structured error object
    if (raw && typeof raw === "object") {
      // Standard Laravel-like payload: { status:false, message:'Validation errors', errors:{...} }
      const message = raw.message || "";
      const errors = raw.errors || {};

      if (/validation errors/i.test(message) && errors && typeof errors === "object") {
        // Handle password rules (merge into one sentence)
        if (Array.isArray(errors.password) && errors.password.length) {
          const clauses = errors.password
            .map(translatePasswordRule)
            .filter(Boolean);

          if (clauses.length) {
            return joinArabicClauses(clauses);
          }
        }

        // You can map other fields if needed (examples included)
        if (Array.isArray(errors.phone) && errors.phone.length) {
          // Common phone issues
          const first = errors.phone[0].toLowerCase();
          if (first.includes("invalid") || first.includes("format")) {
            return "رقم الجوال غير صحيح. أدخل رقم سعودي يبدأ بـ 5 ويتكون من 9 أرقام.";
          }
          if (first.includes("already been taken")) {
            return "رقم الجوال مستخدم مسبقاً.";
          }
        }

        if (Array.isArray(errors.first_name) && errors.first_name.length) {
          return "الاسم الأول مطلوب.";
        }
        if (Array.isArray(errors.last_name) && errors.last_name.length) {
          return "اسم العائلة مطلوب.";
        }

        // Generic validation fallback
        return "حدثت أخطاء في التحقق من البيانات. تأكد من صحة المدخلات.";
      }

      // Other object shapes: try to surface `message`, otherwise stringify
      if (typeof raw.message === "string" && raw.message.trim()) {
        // fall through to string handling below
        raw = raw.message;
      } else {
        raw = ""; // let string fallbacks take over
      }
    }

    // --- String handling (existing logic + tweaks) ---
    const msg = (raw || "").toLowerCase().replace(/\s+/g, " ").trim();
    console.log(msg);

    // Normalize known messages from backend
    const patterns = [
      /user\s+already\s+exist[s]?\s+and\s+is\s+verified.*please\s+login\s+instead\.?/i,
      /already\s+exist[s]?.*verified/i,
    ];

    if (patterns.some((re) => re.test(raw || ""))) {
      return "عندك حساب على نفس رقم الجوال";
    }

    // Default fallback
    return raw || "حدث خطأ غير متوقع. حاول لاحقاً.";
  };



  const handleRegister = async (e) => {
    e.preventDefault();
    setSubmittedOnce(true);
    if (submitting) return;
    setSubmitting(true);
    setError("");

    if (!firstName.trim() || !lastName.trim() || !isValidKsaNational(phoneLocal) ||
      password.length === 0 || passwordConfirmation.length === 0) {
      setSubmitting(false);
      return;
    }
    syncPwValidity(password, passwordConfirmation);
    if (pwConfRef.current && !pwConfRef.current.reportValidity()) {
      setSubmitting(false);
      return;
    }

    const national = normalizeKsaNational(phoneLocal);
    if (!isValidKsaNational(national)) {
      setError("رقم الجوال غير صحيح. أدخل رقم سعودي يبدأ بـ 5 ويتكون من 9 أرقام.");
      setSubmitting(false);
      return;
    }

    const phoneE164 = toE164(national);

    try {
      let fcmToken = undefined;
      try {
        if (typeof window !== "undefined") {
          const result = await initNotifications(VAPID_KEY);
          if (result?.supported && result?.token) fcmToken = result.token;
        }
      } catch (e) {
        console.warn("Skipping FCM token (unsupported or blocked):", e);
      }
      const payload = {
        first_name: firstName,
        last_name: lastName,
        phone: phoneE164, // ✅ send +966 prefix
        password,
        password_confirmation: passwordConfirmation,
        fcm_token: fcmToken || undefined,
      };

      const { data } = await axios.post(`${API_BASE_URL}/register`, payload);

      // New OTP flow
      if (data?.status === true && data?.user_id) {
        localStorage.setItem("pending_verification_user_id", String(data.user_id));
        localStorage.setItem("pending_verification_phone", phoneE164);
        setCurrentView?.("verify");
        setSubmitting(false);
        return;
      }

      // Fallback if backend returns token/user
      if (data?.token && data?.user) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        onLoggedIn?.(data.user);
        setCurrentView ? setCurrentView("home") : onBack?.();
        setSubmitting(false);
        return;
      }

      setError(mapErrorMessage(data));
    } catch (err) {
      setError(mapErrorMessage(err?.response?.data));
    } finally {
      setSubmitting(false);
    }
  };

  const pwConfRef = useRef(null);

  const syncPwValidity = (pw, pwConf) => {
    if (!pwConfRef.current) return;
    if (pwConf && pw !== pwConf) {
      pwConfRef.current.setCustomValidity("كلمتا السر غير متطابقتين");
    } else {
      // مهم: امسح الرسالة إذا صاروا متطابقين
      pwConfRef.current.setCustomValidity("");
    }
  };

  const [touched, setTouched] = useState({
    firstName: false,
    lastName: false,
    phone: false,
    password: false,
    passwordConfirmation: false,
  });
  const [submittedOnce, setSubmittedOnce] = useState(false);

  const markTouched = (key) =>
    setTouched((t) => ({ ...t, [key]: true }));

  // Field-level errors
  const firstNameErr = (touched.firstName || submittedOnce) && !firstName.trim();
  const lastNameErr = (touched.lastName || submittedOnce) && !lastName.trim();
  const phoneErr = (touched.phone || submittedOnce) && !isValidKsaNational(phoneLocal);
  const pwEmptyErr = (touched.password || submittedOnce) && password.length === 0;
  const pwConfErr = (touched.passwordConfirmation || submittedOnce) &&
    (passwordConfirmation.length === 0 || password !== passwordConfirmation);


  return (
    <div dir="rtl" className="page">
      <div className="clip-bg" aria-hidden="true" />
      {/* Back */}
      <motion.button
        className="back-pill"
        onClick={onBack}
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.98 }}
        type="button"
      >
        <span>ارجع للخلف</span>
      </motion.button>

      <div className="shell">
        {/* Right: hero */}
        <section className="heroPane">
          <div className="brand">
            <img src={logo} alt="PARTECH" className="brand-logo" />
          </div>
          <div className="carWrap" aria-hidden>
            <img src={loginCar} alt="Sports car" />
          </div>
        </section>

        {/* Left: form */}
        <section className="formPane">
          <header className="formHeader">
            <h1>إنشاء حساب</h1>
            <p className="register-p">خطوتك الأولى لعالم قطع الغيار</p>
          </header>

          <form onSubmit={handleRegister} className="register-form">
            <label className="field">
              <span className="icon" aria-hidden>
                <img src={nameIcon} alt="" />
              </span>
              <input
                type="text"
                placeholder="الاسم الأول"
                dir="rtl"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                onBlur={() => markTouched("firstName")}
                required
                className={firstNameErr ? "is-error" : ""}
              />
            </label>

            <label className="field">
              <span className="icon" aria-hidden>
                <img src={nameIcon} alt="" />
              </span>
              <input
                type="text"
                placeholder="الاسم الثاني"
                dir="rtl"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                onBlur={() => markTouched("lastName")}
                className={lastNameErr ? "is-error" : ""}
              />
            </label>

            {/* PHONE — icon inside + non-editable +966 pill */}
            <label className="field field--phone">
              <span className="icon" aria-hidden>
                <img src={phoneIcon} alt="" />
              </span>

              {/* The fixed prefix INSIDE the input, not editable */}
              <span className="prefix-ksa" aria-hidden>966+</span>

              <input
                className="ksa-phone-input"
                type="tel"
                inputMode="tel"
                autoComplete="tel"
                placeholder="5xxxxxxxx"
                dir="ltr"
                value={phoneLocal}
                onChange={(e) => handlePhoneChange(e.target.value)}
                onBlur={() => markTouched("phone")}
                required
                pattern="^5\d{8}$"
                title="أدخل رقم جوال سعودي صحيح يبدأ بـ 5 ويتكون من 9 أرقام"
              />
            </label>

            {/* Password */}
            <label className="field field--pw">
              <span className="icon" aria-hidden>
                <img src={passIcon} alt="" />
              </span>
              <input
                type={showPw ? "text" : "password"}
                autoComplete="new-password"
                placeholder="كلمة السر"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  syncPwValidity(e.target.value, passwordConfirmation);
                }}
                onBlur={() => markTouched("password")}
                required
                className={pwEmptyErr ? "is-error" : ""}
              />
              <button type="button" className="eye-btn"
                aria-label={showPw ? "إخفاء كلمة السر" : "إظهار كلمة السر"}
                onClick={() => setShowPw((v) => !v)} >
                <img src={showPw ? eyeOffIcon : eyeIcon} alt="" />
              </button> </label>
            {/* Password confirmation */}
            <label className="field field--pw">
              <span className="icon" aria-hidden>
                <img src={passIcon} alt="" /> </span>
              <input
                ref={pwConfRef}
                type={showPw2 ? "text" : "password"}
                autoComplete="new-password"
                placeholder="تأكيد كلمة السر"
                value={passwordConfirmation}
                onChange={(e) => {
                  setPasswordConfirmation(e.target.value);
                  syncPwValidity(password, e.target.value);
                }}
                onBlur={() => markTouched("passwordConfirmation")}
                required
                className={pwConfErr ? "is-error" : ""}
              />
              <button type="button" className="eye-btn"
                aria-label={showPw2 ? "إخفاء كلمة السر" : "إظهار كلمة السر"}
                onClick={() => setShowPw2((v) => !v)} >
                <img src={showPw2 ? eyeOffIcon : eyeIcon} alt="" />
              </button>
            </label>



            {error && <p className="error-text">{error}</p>}

            <button className="cta" type="submit" disabled={submitting} style={{ marginTop: "0%" }}>
              {submitting ? "..." : "متابعة"}
            </button>

            <div className="signup">
              <span>عندك حساب بالفعل؟ </span>
              <button
                type="button"
                className="accentLink no-underline"
                onClick={() => setCurrentView && setCurrentView("login")}
              >
                سجل دخول
              </button>
            </div>
          </form>
        </section>
      </div>

      {/* Desktop footer stays; mobile footer is a bottom-sheet */}
      <div className="desktop-only">
        <Footer setCurrentView={setCurrentView} />
      </div>
      <div className="hero">
        <MobileFooterSheet mode="sticky" />
      </div>
    </div>
  );
}
